@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../constants/spacing.module.less';

.configure-warehouse-canvas {
  background-color: var(--grey-100);
}

.drawer-header-title {
  align-self: flex-start;
  font-size: 16px;
}

.drawer-header {
  background: var(--grey-200);
  padding: @space-8 @space-12;
}

.scrollable-container {
  overflow: auto;
  justify-content: center;
}
